import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetUserMission {
  status?: string;
  search?: string;
  userin?: string;
  page?: number;
  size?: number;
}

export const getUserMission = ({
  status,
  search = '',
  page,
  size,
  userin = ''
}: GetUserMission) => {
  return HttpService.get(
    `${ApiService.icdc.module.mission.getListUser}?status=${status}&search=&page=1&take=10`
  );
};
